// icons
import React, { useEffect, useRef, useState } from "react";
import styles from "./styles/eventDetail.module.scss";
import { API_ROUTES } from "@/services/environment";
import { Bartender, Booking, EventNote } from "./Interface";
import { useAppSelector } from "@/hooks/hook";
import { DELETE, GET, PATCH, POST } from "@/services/api";
import TimerList from "@/constants/TimerList";
import { toDate, toZonedTime } from "date-fns-tz";
import { format } from "date-fns";
import { CrossIcon, DeleteIcon } from "@/constants/utils/svgs";
import useLoading from "@/hooks/useLoading";
import Alert from "@/components/alert/Alert";
import { EVENT_TYPE_DATA } from "@/constants/Events";
import addIcon from "../../assets/icons/addIcon.svg";
import { COCKTAILS_TYPES_DATA } from "@/constants/CompanyData";
import { FiEdit2 } from "react-icons/fi";
import FormModal from "@/components/modals/FormModal";
import { RiCircleFill } from "react-icons/ri";
import checkedOrange from "../../assets/icons/checkedOrange.svg";
import { AiFillPlusCircle } from "react-icons/ai";
import ScrollToTop from "@/components/ScrollToTop";
import { createPartiallyEmittedExpression } from "typescript";
import { Button, Loader, USFormatePriceWithDecimal } from "@thdinc/hpf-shared";
const forPack = ["water", "seltzer", "beer"];

interface BookingDetailInterface {
  bookingId: string;
  rerender: boolean;
  setRerender: (value: boolean) => void;
}

interface User {
  first_name: string;
  last_name: string;
  roles: string;
  // Add other properties of the user object if available
}

export const EventDetailPage: React.FC<BookingDetailInterface> = ({
  bookingId,
  rerender,
  setRerender,
}) => {
  const {
    getEventDetailApi,
    getAvailableBartendersApi,
    updateBookingBartendersApi,
    getEventNotesApi,
    addEventNoteApi,
    deleteEventNodeApi,
    updateEventNoteApi,
  } = API_ROUTES;
  const { refreshToken } = useAppSelector((store) => store.user);
  //  const user = useAppSelector((store)=> store.user)

  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const { isLoading, startLoading, stopLoading } = useLoading();
  const [isFetching, setIsFetching] = useState(false);
  const [products, setProducts] = useState<any[]>([]);
  const [numberOfCocktailes, setNumberOfCocktailes] = useState<number>();
  const [booking, setBooking] = useState<Booking | null>(null);
  const [availableBarts, setAvailableBarts] = useState<Bartender[]>([]);
  const [selectedBarts, setSelectedBarts] = useState<Bartender[]>([]);
  const [showForm, setShowForm] = useState(false);
  const [noteText, setNoteText] = useState("");
  const [noteList, setNoteList] = useState<EventNote[]>([]);
  const [formState, setFormState] = useState<string>("Add");
  const [noteId, setNoteId] = useState<string>("");
  const canSelectBart =
    booking && 12 <= getNumberOfHours(new Date(), booking?.start_time);
  const [listOfBarts, setListOfBarts] = useState<Bartender[]>([]);
  const shouldSelect: number = booking?.bartenders.length || 0;
  // const selectOrRemoveBart = (id: string) => {
  //   if (selectedBarts.includes(id)) {
  //     const filtered = selectedBarts?.filter((item: string) => item !== id);
  //     setSelectedBarts(filtered);
  //   } else {
  //     if(selectedBarts.length <shouldSelect  )
  //     setSelectedBarts([...selectedBarts, id]);
  //   }
  // };
  // remove br from selected list and add it to available bartender list
  const removeBart = (id: string) => {
    const removedBart = selectedBarts.find((item: Bartender) => item.id === id);
    setSelectedBarts(selectedBarts.filter((item) => item.id !== id));
    removedBart && setAvailableBarts([...availableBarts, removedBart]);
  };
  const addBart = (id: string) => {
    const removedBart = availableBarts.find(
      (item: Bartender) => item.id === id
    );
    setAvailableBarts(availableBarts.filter((item) => item.id !== id));

    removedBart && setSelectedBarts([...selectedBarts, removedBart]);
  };
  const startTime =
    booking && booking?.start_time
      ? TimerList.find(
        (t) =>
          t.value ===
          format(
            toZonedTime(booking?.start_time, booking.business.timezone),
            "HH:mm"
          ).toString()
      )?.label
      : new Date().toString();
  const endTime =
    booking && booking?.end_time
      ? TimerList.find(
        (t) =>
          t.value ===
          format(
            toZonedTime(booking?.end_time, booking?.business.timezone),
            "HH:mm"
          ).toString()
      )?.label
      : new Date().toString();

  // get booking detail
  useEffect(() => {
    const getBookingDetail = async () => {
      try {
        setIsFetching(true);
        const result = await GET(
          `${getEventDetailApi}/${bookingId}`,
          refreshToken
        );
        if (result.data.success) {
          console.log("setBooking", result.data.data);
          setBooking(result.data.data);
          setSelectedBarts(result.data?.data?.bartenders);
        }

        // setListOfBarts([...listOfBarts,...result.data?.bartenders])
      } catch (error) {
        console.error("Error fetching booking details:", error);
      } finally {
        setIsFetching(false);
      }
    };
    const getAvailableBarts = async () => {
      try {
        if (booking) {
          const result = await GET(
            `${getAvailableBartendersApi}?date=${format(
              new Date(booking?.start_time),
              "MM-dd-yyyy"
            )}&startTime=${format(
              toZonedTime(booking?.start_time, booking.business.timezone),
              "HH:mm"
            ).toString()}&endTime=${format(
              toZonedTime(booking?.end_time, booking?.business.timezone),
              "HH:mm"
            ).toString()}&businessId=${booking?.business.id}`,
            refreshToken
          );
          setAvailableBarts(result.data);
          setListOfBarts([...selectedBarts, ...result.data]);
        }
      } catch (error) {
        console.error("Error fetching available bartenders:", error);
      }
    };
    getBookingDetail();
    getAvailableBarts();
  }, [bookingId, booking?.id, rerender]);
  useEffect(() => {
    if (booking) {
      const numberOfHours = getNumberOfHours(
        booking.start_time,
        booking.end_time
      );
      const numberOfCocktails = Math.ceil(booking.guests * (numberOfHours + 1));
      setNumberOfCocktailes(numberOfCocktails);

      //
      const mergedProducts: any = [];
      booking.products.forEach((item: any) => {
        let existingProduct = mergedProducts.find(
          (product: any) => product.productid === item.productid
        );
        if (existingProduct) {
          existingProduct = {
            ...existingProduct,
            quantity:
              parseInt(existingProduct.quantity) + parseInt(item.quantity),
          };
          const index = mergedProducts.findIndex(
            (product: any) => product.product.id === item.product.id
          );
          mergedProducts[index] = existingProduct;
        } else {
          mergedProducts.push({
            ...item,
            product: { ...item.product },
          });
        }
      });
      setProducts(mergedProducts);
    }
  }, [booking]);
  // get notes
  useEffect(() => {
    const getNotesFun = async () => {
      try {
        const res = await GET(`${getEventNotesApi}/${bookingId}`, refreshToken);
        setNoteList(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    if (booking) {
      getNotesFun();
    }
  }, [booking]);
  const inputRef = useRef<HTMLTextAreaElement>(null);
  // Focus on the input when the dropdown opens
  useEffect(() => {
    if (showForm && inputRef.current) {
      inputRef.current.focus();
    }
  }, [showForm]);
  const updateBartender = async () => {
    try {
      startLoading();
      const res = await POST(
        `${updateBookingBartendersApi} `,
        {
          bookingId: booking?.id,
          bartenderId: selectedBarts.map((item: Bartender) => item.id),
        },
        refreshToken
      );
      if (res.data.success) {
        setRerender(!rerender);
        Alert({ message: res?.data?.message });
      }
    } catch (error) {
      console.log(error);
      Alert({ type: "error", message: "Something went wrong" });
    } finally {
      stopLoading();
    }
  };
  const addUpdateNoteFun = async () => {
    try {
      let response: any;
      if (noteText !== "") {
        if (formState === "Add") {
          response = await POST(
            addEventNoteApi + "/" + bookingId,
            { note: noteText, businessId: booking?.business.id },
            refreshToken
          );
        } else {
          response = await PATCH(
            updateEventNoteApi + "/" + noteId,
            { note: noteText, bookingId, businessId: booking?.business.id },
            refreshToken
          );
        }
        if (response.data.success) {
          Alert({ message: response?.data?.message });
          setShowForm(false);
          setNoteText("");
          if (formState === "Add") {
            setNoteList([...noteList, { ...response?.data?.data }]);
          } else {
            setNoteList(
              noteList.map((note: EventNote) => {
                if (note.id === noteId) {
                  return response?.data?.data;
                }
                return note;
              })
            );
          }
        }
      } else {
        Alert({ type: "error", message: `Note can't be empty` });
      }
    } catch (error) {
      console.log(error);
    }
  };
  const deleteNoteFun = async (noteId: string) => {
    try {
      const response = await DELETE(
        deleteEventNodeApi + "/" + noteId,
        refreshToken
      );
      if (response?.data?.success) {
        Alert({ message: response?.data?.message });
        const filtered = noteList.filter(
          (note: EventNote) => note.id !== noteId
        );
        setNoteList(filtered);
      }
    } catch (error) {
      console.log(error);
    }
  };
  // const productListWithCocktail = booking?.products && booking.products.length > 0 ? booking.products : [];
  // const productList = productListWithCocktail.filter((item:any) => item.cocktailId);
  // const allZero = productList.length > 0 && productList.every((item: any) => item.isbtcprovide == false);
  // const allGreaterThanZero = productList.length > 0 && productList.every((item: any) => item.isbtcprovide);
  // const mixed = productList.length > 0 && !allZero && !allGreaterThanZero;
  // const isalcoholProvideByBrtenderCompany = productList.length > 0 && (allGreaterThanZero || mixed);
  // const isalcoholArrangeByCustomer = productList.length > 0 && (allZero || mixed);
  const isAlcoholFn = (productList: any) => {
    const cocktailAlcohol = productList?.filter(((i: any) => i.cocktailid))
    const isalcoholProvideByBrtenderCompany =
      cocktailAlcohol?.length > 0 && cocktailAlcohol?.filter((item: any) => item.isbtcprovide)?.length > 0;
    const isalcoholArrangeByCustomer =
      cocktailAlcohol?.length > 0 &&
      cocktailAlcohol?.filter((item: any) => item.isbtcprovide == false)?.length > 0;
    return {
      bartenderProvideAlcohol: isalcoholProvideByBrtenderCompany,
      customerProvideAlcohol: isalcoholArrangeByCustomer,
    };
  };
  const alcoholStatus = isAlcoholFn(booking?.products)
  function getNumberOfBartenders(guests: number, guestsPerBartender: number) {
    return Math.ceil(guests / guestsPerBartender);
  }
  const [guestsByPackageSelection, setGuestsByPackageSelection] = useState<number>(0)
  useEffect(() => {
    if (booking) {
      const guestsPerBartenderCustom =
        booking.iscocktail == false && booking.isbeer == false && booking.iswine == false
          ? booking.package.guests_per_bartender
          : booking.iscocktail == true
            ? booking.package.guests_per_bartender
            : booking.package.guests_per_beer;
      const guestsPerBartender =
        booking.package.type == 'custom_package'
          ? guestsPerBartenderCustom
          : booking.package.guests_per_bartender;

      setGuestsByPackageSelection(guestsPerBartender)
    }
  }, [booking])
  return (
    <section className={`${styles.container}`}>
      <ScrollToTop />
      {!isFetching ? (
        <>
          <div className="mt-3 ">
            {/* <Button  onClick={downloadPdf}>Download</Button> */}
          </div>

          {booking ? (
            <div className="flex gap-8 md:flex-row flex-col">
              {/* Left */}
              <div className="flex flex-col gap-7 md:w-8/12 ">
                {/*Bartenders Assigned: */}
                {booking && booking?.bartenders?.length > 0 && (
                  <div
                    className={`bg-white p-5 rounded-xl ${booking.auto_selected ? "border border-primary-red" : ""
                      }`}
                  >
                    <div>
                      {/* <img
                    src={brtnderImg}
                    width={35}
                    height={35}
                    alt="Happiest Ours"
                  /> */}
                      <div className="flex justify-between  mb-4 sm:mb-3 ">
                        <div className="flex items-center gap-2 sm:gap-3 flex-wrap">
                          <p className="text-2xl font-semibold ">Bartenders</p>
                          {booking.auto_selected ? (
                            <div className="bg-[#fcd7d4] px-3  py-1 rounded-full  ">
                              <p className="text-[#FF6100] text-xs font-bold">
                                {" "}
                                Unassigned
                              </p>
                            </div>
                          ) : (
                            <div className="bg-[#ccf0eb] px-3  py-1 rounded-full">
                              <p className="text-[#00B69B] text-xs font-bold">
                                Assigned
                              </p>
                            </div>
                          )}
                        </div>

                        <p className=" my-2 font-medium bg-p-gray rounded-full px-3 py-2 text-xs text-center sm:text-start">
                          {booking?.bartenders?.length > 1
                            ? `Select ${booking.bartenders.length} bartenders`
                            : "Select 1 Bartender"}
                        </p>
                      </div>

                      {/* <p className={styles.fontBold}>Add-ons:</p> */}

                      <div className="flex gap-5 flex-wrap justify-center sm:justify-start">
                        {listOfBarts.map((item: Bartender, i) => {
                          return (
                            <div
                              onClick={() => {
                                if (canSelectBart) {
                                  if (
                                    selectedBarts
                                      .map((i) => i.id)
                                      .includes(item.id)
                                  ) {
                                    removeBart(item.id);
                                  } else {
                                    if (
                                      // shouldSelect > selectedBarts.length &&
                                      canSelectBart
                                    ) {
                                      addBart(item.id);
                                    }
                                  }
                                }
                              }}
                              key={i}
                              className={`flex flex-col gap-2 items-center cursor-pointer `}
                            >
                              <div className="relative">
                                <img
                                  className={`w-[114px] h-[114px]   object-cover rounded-xl ${selectedBarts
                                    .map((i) => i.id)
                                    .includes(item.id) &&
                                    "border-orange-500 border-4  "
                                    } `}
                                  src={item.avatar}
                                  alt="bar"
                                />
                                {selectedBarts
                                  .map((i) => i.id)
                                  .includes(item.id) && (
                                    <img
                                      src={checkedOrange}
                                      className="absolute top-2 right-2"
                                    />
                                  )}
                              </div>
                              <div>
                                <p className="text-sm font-semibold">
                                  <span className=" rounded-full bg-primary-red w-1 h-3 inline-block mr-2"></span>
                                  {item.first_name + " " + item.last_name}{" "}
                                </p>
                                {/* <div
                              className="cursor-pointer"
                           
                              onClick={() => removeBart(item.id)}
                            >
                              {canSelectBart && <DeleteIcon />}
                            </div> */}
                              </div>
                            </div>
                          );
                        })}
                      </div>

                      {canSelectBart && (
                        <div className="text-end">
                          <Button
                            onClick={updateBartender}
                            disabled={!(shouldSelect === selectedBarts.length)}
                            classes={`  ${shouldSelect === selectedBarts.length
                              ? "bg-primary-red hover:bg-prtimary-red-button-hover text-white  "
                              : "bg-gray-300 text-gray-500"
                              }   px-6 bg-[#ff5100]  `}
                          >
                            {" "}
                            {isLoading ? <Loader color="bg-gray-50" /> : "Save"}
                          </Button>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {/* Card */}
                <div className="bg-white p-5 rounded-xl overflow-x-auto">
                  <div className="flex justify-between items-center">
                    <p className="text-2xl font-semibold ">Event Overview</p>
                    {/* Tags */}
                    <div className="flex gap-2 flex-wrap">
                      <div className="flex gap-1 bg-p-gray rounded-full py-2 px-4 text-xs font-semibold tracking-wider ">
                        <p>Type:</p>
                        <p className="">
                          {" "}
                          {EVENT_TYPE_DATA &&
                            EVENT_TYPE_DATA.find(
                              (a: any) => a.value === booking?.eventtype
                            )?.name}
                        </p>
                      </div>
                      <div className="flex gap-1 bg-p-gray rounded-full py-2 px-4 text-xs font-semibold tracking-wider ">
                        <p>Venue:</p>
                        <p className="capitalize"> {booking?.eventsite}</p>
                      </div>
                      <div className="flex gap-1 bg-p-gray rounded-full py-2 px-4 text-xs font-semibold tracking-wider ">
                        <p>Tip:</p>
                        <p className="capitalize">
                          {" "}
                          {booking?.tips ? "Yes" : "No"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col gap-5 mt-4">
                    {/* section */}
                    {/* Col */}
                    <div className="flex flex-col gap-1">
                      <h1 className="flex items-center gap-2 text-lg font-semibold">
                        <span className=" rounded-full bg-primary-red w-1 h-3 inline-block"></span>{" "}
                        Client Details
                      </h1>
                      {/* row */}
                      <div className="ml-3 flex gap-3 mt-2 text-[15px]">
                        <p className="font-semibold">Client: </p>
                        <p className="text-gray-600 ">
                          {booking?.first_name + " " + booking?.last_name}
                        </p>
                      </div>
                      {/* row */}
                      <div className="ml-3  flex gap-3  text-[15px] ">
                        <p className="font-semibold">Phone: </p>
                        <p>
                          {booking &&
                            booking?.phone}
                        </p>
                      </div>
                      {/* row */}
                      <div className="ml-3  flex gap-3  text-[15px] ">
                        <p className="font-semibold">Email: </p>
                        <p>
                          {booking &&
                            booking?.email}
                        </p>
                      </div>
                      {/* row */}
                      <div className="ml-3  flex gap-3  text-[15px] ">
                        <p className="font-semibold">Address: </p>
                        <p>
                          {booking &&
                            booking?.address1 +
                            ", " +
                            booking.city +
                            ", " +
                            booking.state +
                            ", " +
                            booking.postalcode}
                        </p>
                      </div>
                    </div>
                    {/* section */}
                    {/* Col */}
                    <div className="flex flex-col gap-1 mt-3">
                      <h1 className="flex items-center gap-2 text-lg font-semibold">
                        <span className=" rounded-full bg-primary-red w-1 h-3 inline-block"></span>{" "}
                        Event Details
                      </h1>

                      {/* row */}
                      <div className="ml-3 flex gap-3 mt-2  text-[15px]">
                        <p className="font-semibold">Date: </p>
                        <p className="text-gray-600">
                          {booking &&
                            format(new Date(booking?.start_time), "MM-dd-yyyy")}
                        </p>
                      </div>
                      {/* row */}
                      <div className="ml-3  flex gap-3  text-[15px]">
                        <p className="font-semibold">Time: </p>
                        <p>{startTime + " - " + endTime}</p>
                      </div>
                      <div className="ml-3  flex gap-2  text-[15px]">
                        <p className="font-semibold">Guests: </p>
                        <p>{booking?.guests}</p>
                      </div>
                      {(booking?.notes !== "" ||
                        booking?.addons.length > 0 ||
                        booking.customAddons.length > 0) && (
                          <div className="bg-p-gray rounded-xl p-3 mt-4">
                            <p className=" font-semibold">Additional Details</p>

                            {booking && booking?.notes !== "" && (
                              <div>
                                <p className=" text-sm font-semibold">Notes</p>
                                <p className="text-sm">{booking.notes}</p>
                              </div>
                            )}
                            {booking && booking?.addons.length > 0 && (
                              <div className="flex gap-2 items-center flex-wrap">
                                <p className=" font-semibold">Add-ons:</p>
                                {booking.addons.map((item, i) => {
                                  return (
                                    <div key={i}>
                                      <p className=" text-sm ">{item.name}, </p>
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                            {booking && booking?.customAddons.length > 0 && (
                              <div>
                                <p className=" font-semibold">Custom Add-ons:</p>
                                <div className="flex gap-2 items-center flex-wrap mt-2">
                                  {booking.customAddons.map((item, i) => {
                                    return (
                                      <div
                                        className=" bg-white  p-3  rounded-xl font-semibold"
                                        key={i}
                                      >
                                        <p className=" text-sm ">
                                          {" "}
                                          <span className="">Price: </span>{" "}
                                          <span className="text-gray-600">
                                            {" "}
                                            ${(item.price / 100).toFixed(2)}
                                          </span>
                                        </p>
                                        <p className=" text-sm ">
                                          {" "}
                                          <span className="text-gray-500">
                                            {" "}
                                            {item.description}
                                          </span>{" "}
                                        </p>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                    </div>
                  </div>
                </div>

                {/* Cocktails & Ingredients: */}
                {booking.package.type === 'custom_package' && (booking.cocktails && booking?.cocktails?.length > 0) && <div className="bg-white p-5 rounded-xl">
                  <div className={styles.scrollable}>
                    {/* <img
                  src={cocktailImg}
                  width={30}
                  height={30}
                  alt="Happiest Ours"
                /> */}
                    <p className="text-2xl font-semibold ">
                      Cocktails & Ingredients
                    </p>

                    {/*  Cocktial Grid */}
                    <table
                      className="w-full min-w-96 overflow-x-scroll"
                      // className={styles.cocktailTable}
                      style={{ marginTop: "10px" }}
                    >
                      <thead>
                        <tr>
                          <th
                            style={{ textAlign: "start", paddingLeft: "20px" }}
                          ></th>
                          <th className="text-start font-semibold">
                            Ingredients
                          </th>
                          <th className="text-start font-semibold">Quantity</th>
                        </tr>
                      </thead>
                      <tbody>
                        {booking?.cocktails &&
                          booking?.cocktails.map((i, index) => {
                            return (
                              <tr key={index}>
                                <td className="min-w-72">
                                  {" "}
                                  <div key={index} className="flex gap-4">
                                    <img
                                      src={i?.image || ""}
                                      alt="Business image "
                                      className="h-20 w-20 rounded-md mb-5"
                                    />
                                    <div>
                                      <p className="capitalize">{i.name}</p>
                                      {/* <span>{i.type}</span> */}
                                      <small className="text-primary-red">
                                        <span>
                                          {" "}
                                          {COCKTAILS_TYPES_DATA &&
                                            COCKTAILS_TYPES_DATA.find(
                                              (a: any) => a.value === i.type
                                            )?.name}
                                        </span>
                                      </small>
                                      <div>
                                        {" "}
                                        <p className="text-xs">{i.note}</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                {/* list of ingrediants */}
                                <td className="">
                                  {i?.ingredients &&
                                    i?.ingredients.length > 0 &&
                                    i?.ingredients.map(
                                      (ing: any, i: number) => {
                                        return (
                                          <div
                                            className="text-gray-600 h-full"
                                            key={i}
                                          >
                                            <p className="text-sm">
                                              {ing.name}
                                            </p>
                                          </div>
                                        );
                                      }
                                    )}
                                </td>
                                <td className="min-w-54">
                                  {i?.ingredients &&
                                    i?.ingredients.length > 0 &&
                                    i?.ingredients.map(
                                      (ing: any, i: number) => {
                                        return (
                                          <div
                                            style={{ marginTop: "5px" }}
                                            key={i}
                                            // className={styles.qnty}
                                            className="text-primary-red text-xs font-semibold"
                                          >
                                            {numberOfCocktailes &&
                                              Math.ceil(
                                                ((ing.qty_oz / 100) *
                                                  numberOfCocktailes) /
                                                3
                                              )}
                                            Oz
                                          </div>
                                        );
                                      }
                                    )}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </div>}
                {booking.package.type === 'standard' && <div className="bg-white p-5 rounded-xl">
                  <div className={styles.scrollable}>
                    {/* <img
                  src={cocktailImg}
                  width={30}
                  height={30}
                  alt="Happiest Ours"
                /> */}
                    <p className="text-2xl font-semibold ">
                      Cocktails & Ingredients
                    </p>

                    {/*  Cocktial Grid */}
                    <table
                      className="w-full min-w-96 overflow-x-scroll"
                      // className={styles.cocktailTable}
                      style={{ marginTop: "10px" }}
                    >
                      <thead>
                        <tr>
                          <th
                            style={{ textAlign: "start", paddingLeft: "20px" }}
                          ></th>
                          <th className="text-start font-semibold">
                            Ingredients
                          </th>
                          <th className="text-start font-semibold">Quantity</th>
                        </tr>
                      </thead>
                      <tbody>
                        {booking?.cocktails &&
                          booking?.cocktails.map((i, index) => {
                            return (
                              <tr key={index}>
                                <td className="min-w-72">
                                  {" "}
                                  <div key={index} className="flex gap-4">
                                    <img
                                      src={i?.image || ""}
                                      alt="Business image "
                                      className="h-20 w-20 rounded-md mb-5"
                                    />
                                    <div>
                                      <p className="capitalize">{i.name}</p>
                                      {/* <span>{i.type}</span> */}
                                      <small className="text-primary-red">
                                        <span>
                                          {" "}
                                          {COCKTAILS_TYPES_DATA &&
                                            COCKTAILS_TYPES_DATA.find(
                                              (a: any) => a.value === i.type
                                            )?.name}
                                        </span>
                                      </small>
                                      <div>
                                        {" "}
                                        <p className="text-xs">{i.note}</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                {/* list of ingrediants */}
                                <td className="">
                                  {i?.ingredients &&
                                    i?.ingredients.length > 0 &&
                                    i?.ingredients.map(
                                      (ing: any, i: number) => {
                                        return (
                                          <div
                                            className="text-gray-600 h-full"
                                            key={i}
                                          >
                                            <p className="text-sm">
                                              {ing.name}
                                            </p>
                                          </div>
                                        );
                                      }
                                    )}
                                </td>
                                <td className="min-w-54">
                                  {i?.ingredients &&
                                    i?.ingredients.length > 0 &&
                                    i?.ingredients.map(
                                      (ing: any, i: number) => {
                                        return (
                                          <div
                                            style={{ marginTop: "5px" }}
                                            key={i}
                                            // className={styles.qnty}
                                            className="text-primary-red text-xs font-semibold"
                                          >
                                            {numberOfCocktailes &&
                                              Math.ceil(
                                                ((ing.qty_oz / 100) *
                                                  numberOfCocktailes) /
                                                3
                                              )}
                                            Oz
                                          </div>
                                        );
                                      }
                                    )}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </div>}
                {/* Total Alcohol and Water provided for the Event: */}
                {products.length > 0 && (
                  <div className="bg-white p-5 rounded-xl">
                    <div className={styles.scrollable}>
                      {/* <img
                    src={totalDrink}
                    width={30}
                    height={30}
                    alt="Happiest Ours"
                  /> */}
                      <p className="text-2xl font-semibold ">
                        Total Alcohol and Water provided for the Event
                      </p>
                      {/*  Cocktial Grid */}
                      <table
                        className={styles.cocktailTable}
                        style={{ marginTop: "10px" }}
                      >
                        <thead>
                          {/* <tr>
                      <th style={{ textAlign: "start", paddingLeft: "20px" }}>
                        Type
                      </th>
                      <th style={{ textAlign: "start" }}>Brand</th>
                      <th style={{ textAlign: "start" }}>Quantity</th>
                    </tr> */}
                        </thead>
                        <tbody>
                          {products.length > 0 &&
                            products.map((i: any, index: number) => {
                              return (
                                <tr key={index}>
                                  <td className="fke">
                                    {" "}
                                    <div
                                      key={index}
                                      className={styles.cocktailFlex}
                                    >
                                      <img
                                        src={i?.product.image || ""}
                                        alt="Business image"
                                        className="w-24 h-24"
                                      />
                                      <div className="font-semibold">
                                        {/* <p> {i.product.type}</p> */}
                                        <p>
                                          {" "}
                                          {COCKTAILS_TYPES_DATA &&
                                            COCKTAILS_TYPES_DATA.find(
                                              (a: any) =>
                                                a.value === i.product.type
                                            )?.name}
                                        </p>
                                        <div className="text-xs   ">
                                          <p className="text-primary-red">
                                            {i.product.name}
                                          </p>
                                          <p className="text-gray-500 mt-3">
                                            {forPack.includes(i.product.type)
                                              ? i.product.quantity
                                              : i.product.size + "ml"}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  {/* list of ingrediants */}
                                  {/* <td>
                              <p>{i.product.name}</p>
                            </td> */}
                                  <td className="flex justify-center">
                                    <div className="text-xs text-gray-600 font-semibold p-2 px-3 rounded-full bg-p-gray w-fit mt-3">
                                      {" "}
                                      {i.quantity + " "}
                                      {forPack.includes(i.product.type)
                                        ? "Pack"
                                        : "Bottles"}{" "}
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
                {/* Additional Details: */}
                {/* {booking && booking.addons.length > 0 && (
            <div className="bg-white p-5 rounded-xl">
              <div style={{ width: "100%" }}>
                <p className="text-2xl font-semibold ">Additional Details:</p>
                <h1 className="flex items-center gap-2  font-semibold my-5">
                  <span className=" rounded-full bg-primary-red w-1 h-3 inline-block"></span>{" "}
                  Add-ons
                </h1>

                <div className="grid grid-cols-3 gap-8">
                  {booking.addons.map((item, i) => {
                    return (
                      <div key={i} className={styles.row}>
                        {item.image !== null && item.image !== "" ? (
                          <img
                            className="w-16 h-16 rounded-md object-cover"
                            src={item?.image || ""}
                            alt="bar"
                          />
                        ) : (
                          <div className="w-16 h-16 rounded-md object-cover "></div>
                        )}
                        <p className="font-semibold text-sm ">{item.name}</p>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )} */}
                {/* Company Details */}
                <div className="bg-white p-5 rounded-xl flex flex-col gap-6 overflow-hidden ">
                  {/* <img
                  src={companyImg}
                  width={30}
                  height={30}
                  alt="Happiest Ours"
                /> */}
                  <p className="text-2xl font-semibold ">Company Details</p>
                  <div className="flex gap-2 flex-col sm:flex-row">
                    <img
                      src={booking?.business?.logo || ""}
                      alt="Business image"
                      className="w-28 h-28 object-cover rounded-md"
                    />
                    <div className="flex flex-col text-[15px]">
                      <p className="font-semibold text-lg ">
                        {" "}
                        {booking?.business?.name}
                      </p>
                      <div className="flex gap-3 mt-2 ">
                        <p className="font-semibold">Phone: </p>
                        <p className="text-gray-600">
                          {booking?.business?.phone_number}
                        </p>
                      </div>
                      <div className=" flex gap-3 ">
                        <p className="font-semibold">Email: </p>
                        <p className="text-gray-600">
                          {booking?.business?.email}
                        </p>
                      </div>
                      <div className=" flex gap-3 ">
                        <p className="font-semibold">Address: </p>
                        <p className="text-gray-600">
                          {booking?.business?.address1}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="bg-p-gray rounded-lg p-3 w-full">
                    <div>
                      <p className="font-semibold text-lg">
                        Package Name:{" "}
                        <span className="text-gray-500">
                          {booking?.package.name}
                        </span>
                      </p>
                      {booking.package.type !== 'custom_package' &&
                        <>
                          <div>
                            <p className="font-semibold my-3">Included</p>
                          </div>
                          <div className="grid grid-cols-2 gap-2">
                            {booking &&
                              booking?.package.supplies.map((item, i) => {
                                return (
                                  <h1
                                    key={i}
                                    className="flex items-center gap-2  font-semibold text-gray-500"
                                  >
                                    <span className=" rounded-full bg-primary-red w-1 h-3 inline-block"></span>{" "}
                                    {item}
                                  </h1>
                                );
                              })}
                          </div>
                        </>
                      }
                    </div>
                  </div>
                </div>
              </div>
              {/* Right section */}
              <div className="flex flex-col  md:w-5/12  gap-7">
                <div className=" bg-white px-5 pb-4 rounded-xl  relative overflow-y-auto">
                  <div className="flex justify-between items-center py-2 bg-white sticky left-2 right-2 top-0">
                    <p className="text-2xl font-semibold ">Additional Notes</p>
                    <div
                      onClick={() => {
                        setFormState("Add");
                        setNoteText("");
                        setShowForm(!showForm);
                      }}
                      className=" inline-block  rounded-full cursor-pointer"
                    >
                      {/* <img src={addIcon} width={15} height={15} /> */}
                      <AiFillPlusCircle
                        className="text-primary-red"
                        size={25}
                      />
                    </div>
                  </div>
                  {/* Add or adit form */}
                  <FormModal
                    modalTitle="Add Note"
                    width="w-full md:w-[550px]"
                    isOpen={showForm}
                    onClose={() => setShowForm(false)}
                  >
                    <textarea
                      ref={inputRef}
                      rows={5}
                      value={noteText}
                      onChange={(e) => setNoteText(e.target.value)}
                      className=" w-full  p-3 bg-p-gray rounded-xl    focus:outline-none  focus:ring-1 focus:ring-primary-red  text-gray-600"
                      name=""
                      id=""
                    ></textarea>
                    <div className="text-end">
                      <Button
                        classes={`  ${noteText.length > 0
                          ? "bg-primary-red hover:bg-primary-red-button-hover text-white  "
                          : "bg-gray-300 text-gray-500"
                          }   px-6 bg-[#ff5100]  `}
                        onClick={addUpdateNoteFun}
                      >
                        {formState === "Add" ? "Add" : "Update"}
                      </Button>
                    </div>
                  </FormModal>
                  {/* Notes list */}
                  <div className="flex flex-col max-h-80 mt-3">
                    {/* Notes card */}
                    {noteList.length > 0 &&
                      noteList?.map((data: EventNote) => {
                        const { id, date, note, created_by, modified_by } =
                          data;
                        return (
                          <div
                            key={id}
                            className="bg-p-gray p-3 rounded-xl mt-4"
                          >
                            <div className="flex justify-between ">
                              <div className=" group  flex gap-2">
                                <p className="flex items-center gap-2  font-semibold">
                                  <span className=" rounded-full bg-primary-red w-1 h-3 inline-block"></span>{" "}
                                  Added By:
                                </p>
                                <p className=" text-gray-500">{created_by}</p>
                              </div>

                              <div className="flex gap-2 items-center  ">
                                <div
                                  className="cursor-pointer"
                                  onClick={() => {
                                    setFormState("Update");
                                    setShowForm(true);
                                    setNoteText(note);
                                    setNoteId(id);
                                  }}
                                >
                                  <FiEdit2 size={14} />
                                </div>
                                <div
                                  className=" cursor-pointer"
                                  onClick={() => deleteNoteFun(id)}
                                >
                                  <DeleteIcon />
                                </div>
                              </div>
                            </div>
                            {modified_by && (
                              <div className=" group  flex gap-2">
                                <p className="flex items-center gap-2  font-semibold">
                                  <span className=" rounded-full bg-primary-red w-1 h-3 inline-block"></span>{" "}
                                  Modified By:
                                </p>
                                <p className=" text-gray-500">{modified_by}</p>
                              </div>
                            )}
                            <div className="flex gap-2 ">
                              <p className="flex items-center gap-2  font-semibold">
                                <span className=" rounded-full bg-primary-red w-1 h-3 inline-block"></span>{" "}
                                Date:
                              </p>
                              <p className=" text-gray-500">
                                {" "}
                                {booking &&
                                  format(new Date(date), "MM-dd-yyyy")}
                              </p>
                            </div>
                            <div className="flex gap-2 items-start ">
                              <p className="  font-semibold min-w-28">
                                Note Detail:
                                <span className=" text-gray-500 text-sm font-normal ml-2">
                                  {note}
                                </span>
                              </p>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>

                <div className=" bg-white p-5 rounded-xl">
                  <div>
                    <div>
                      {/* <img
                  src={financialImg}
                  width={30}
                  height={30}
                  alt="Happiest Ours"
                /> */}
                      <p className="text-2xl font-semibold ">
                        Financial Summary
                      </p>
                      {/* <PackageDetails pkg={booking.package} image={booking.business.logo} /> */}
                      {booking && (
                        <div className="flex gap-5 my-3">
                          <img
                            className="w-24 h-24 object-cover rounded-md "
                            src={booking.business.logo}
                            alt=""
                          />
                          <div className="flex flex-col gap-1">
                            <p className="font-bold">{booking.package.name}</p>
                            <div className="font-semibold text-xs text-primary-red">
                              <p>{`1 Bartender per ${guestsByPackageSelection} guests`}</p>
                              <p className="capitalize">{booking?.iscocktail && 'Cocktail'} {booking?.isbeer && 'Beer'} {booking?.iswine && 'Wine'}</p>

                            </div>
                            <div className=" gap-1 flex-wrap hidden lg:flex">
                              {booking.package.supplies.length > 0 &&
                                booking.package.supplies.map((sup, i) => {
                                  return (
                                    <p
                                      key={i}
                                      className=" font-semibold text-xs text-gray-500 tracking-wide"
                                    >
                                      {sup},
                                    </p>
                                  );
                                })}
                            </div>
                            {/* <p className=" font-semibold text-xs text-gray-500 tracking-wide">
                        {booking.package.supplies
                          .toString()
                          .split(" ")
                          .join(", ")}
                      </p> */}
                          </div>
                        </div>
                      )}
                      {booking && (
                        <div className=" gap-1 flex-wrap flex lg:hidden">
                          {booking.package.supplies.length > 0 &&
                            booking.package.supplies.map((sup, i) => {
                              return (
                                <p
                                  key={i}
                                  className=" font-semibold text-xs text-gray-500 tracking-wide"
                                >
                                  {sup},
                                </p>
                              );
                            })}
                        </div>
                      )}
                      <div style={{ marginTop: "8px" }}>
                        <div className={styles.bottomDivder}></div>
                      </div>
                      <div className="flex flex-col gap-2  my-5">
                        <div className="flex justify-between items-center font-semibold text-sm px-3">
                          <p className="text-black ">Package </p>
                          <p className="font-semibold text-sm text-gray-500">
                            $
                            {booking &&
                              USFormatePriceWithDecimal(
                                booking?.package_total / 100
                              )}
                          </p>
                        </div>
                        {booking && !booking.tips && booking?.tips_total > 0 && (
                          <div className="flex justify-between items-center font-semibold text-sm px-3">
                            <p className="text-black ">Tips Totals </p>
                            <p className="font-semibold text-sm text-gray-500">
                              $
                              {USFormatePriceWithDecimal(
                                booking?.tips_total / 100
                              )}
                            </p>
                          </div>
                        )}
                        {booking
                          ? booking.discount_total > 0 && (
                            <div className="flex justify-between items-center font-semibold text-sm px-3">
                              <p className="text-black ">Discount </p>
                              <p className="font-semibold text-sm text-gray-500">
                                -$
                                {USFormatePriceWithDecimal(
                                  roundUpPrice(booking?.discount_total / 100)
                                )}
                              </p>
                            </div>
                          )
                          : ""}

                        {booking
                          ? booking.addons_total > 0 && (
                            <div className="flex justify-between items-center font-semibold text-sm px-3">
                              <p className="text-black ">Add-ons </p>
                              <p className="font-semibold text-sm text-gray-500">
                                $
                                {USFormatePriceWithDecimal(
                                  roundUpPrice(booking?.addons_total / 100)
                                )}
                              </p>
                            </div>
                          )
                          : ""}
                        {booking &&
                          booking.customAddons.length &&
                          booking?.customaddonstotal ? (
                          <div className="flex justify-between items-center font-semibold text-sm px-3">
                            <p className="text-black ">Custom Add-ons </p>
                            <p className="font-semibold text-sm text-gray-500">
                              $
                              {USFormatePriceWithDecimal(
                                roundUpPrice(booking?.customaddonstotal / 100)
                              )}
                            </p>
                          </div>
                        ) : (
                          ""
                        )}
                        {/* <div className="flex justify-between items-center font-semibold text-sm px-3">
                          <p className="text-black ">Delivery Total </p>
                          <p className="font-semibold text-sm text-gray-500">
                            $
                            {booking &&
                              USFormatePriceWithDecimal(
                                roundUpPrice(booking?.delivery_total / 100)
                              )}
                          </p>
                        </div> */}
                        <div className="flex justify-between items-center font-semibold text-sm px-3">
                          <p className="text-black">Platform Fee </p>
                          <p className="font-semibold text-gray-500">
                            $
                            {booking &&
                              USFormatePriceWithDecimal(
                                roundUpPrice(booking?.service_fees / 100)
                              )}
                          </p>
                        </div>
                        <div className="flex items-center justify-between bg-p-gray px-4  h-[63px] rounded-xl  mt-5">
                          <p className="font-semibold">Total Package</p>
                          <p className="font-semibold">
                            $
                            {booking && booking.discount_total !== 0
                              ? USFormatePriceWithDecimal(
                                roundUpPrice(
                                  (booking.service_total -
                                    booking.discount_total) /
                                  100
                                )
                              )
                              : booking &&
                              USFormatePriceWithDecimal(
                                roundUpPrice(booking.service_total / 100)
                              )}{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    {/* Alchocal estimation */}
                    {booking?.producttotaltwoone !== null ? (
                      <div className={`mt-4 `}>
                        <div
                          style={{ position: "relative" }}
                          className={styles.rowFlex}
                        >
                          <div className="flex gap-2  text-sm px-3 items-center">
                            <div className="text-black font-semibold">
                              Estimated Alcohol
                            </div>
                            <IButton
                              message="This estimate represents the projected alcohol expenditure for your event. Following the event, charges will apply only to the bottles that were opened, offering an excellent opportunity to save money!"
                              iconColor="#4A5568"
                              messageWidth="300px"
                            />
                          </div>

                          <p className="font-semibold text-gray-500">
                            $
                            {booking &&
                              USFormatePriceWithDecimal(
                                roundUpPrice(booking?.producttotal / 100)
                              )}
                          </p>
                        </div>

                        {/* <div className={styles.bottomDivder}></div> */}
                        {booking &&

                          //  (booking?.producttotal / 100)>0
                          ((booking.iscocktail && !booking?.isbeer && !booking?.iswine) || (booking.iscocktail && booking.isbeer && booking?.iswine) || (booking?.cocktails && booking?.cocktails.length > 0))
                          && (
                            <div className={styles.rowFlex}>
                              <p className="text-xs text-left px-3 mt-1">
                                {`This works out to an estimated $${booking &&
                                  numberOfCocktailes &&
                                  USFormatePriceWithDecimal(
                                    (
                                      Math.round(
                                        (booking.service_total -
                                          booking?.discount_total +
                                          booking.producttotaltwoone -
                                          booking.producttaxes) /
                                        numberOfCocktailes
                                      ) / 100
                                    ).toFixed(2)
                                  )
                                  } per cocktail`}
                              </p>
                            </div>
                          )}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                {/* Payment dates card */}
                <div className=" bg-white p-5 rounded-xl">
                  <div>
                    <p className="font-semibold text-lg">Payment Dates </p>
                    <p className="text-primary-red text-xs mb-1 mt-4 px-3">
                      Pre Event Payment
                    </p>
                    <div className="flex justify-between items-center bg-p-gray p-3 rounded-xl h-[63px]">
                      <p>
                        {booking &&
                          format(new Date(booking?.created_at), "MM-dd-yyyy")}
                      </p>
                      <p className="font-semibold text-gray-500">
                        {booking && booking.pendingamount === 0
                          ? `$${USFormatePriceWithDecimal(
                            roundUpPrice(
                              (booking?.service_total -
                                booking.discount_total) /
                              100
                            )
                          )}`
                          : booking &&
                          `$${roundUpPrice(
                            calculateFirstHalfPayment(
                              booking?.service_total,
                              booking?.service_fees,
                              booking.discount_total
                            ) / 100
                          )}`}
                      </p>
                    </div>
                    {booking && booking.pendingamount !== 0 && (
                      <div>
                        <p className="text-primary-red text-xs mb-1 mt-4 px-3">
                          Post Event Payment
                        </p>
                        <div className="flex justify-between bg-p-gray p-3 rounded-xl h-[63px]">
                          <p>
                            {booking &&
                              format(
                                new Date(booking.start_time).setDate(
                                  new Date(booking.start_time).getDate() - 2
                                ),
                                "MM-dd-yyyy"
                              )}{" "}
                          </p>
                          <p className="font-semibold text-gray-500">
                            <p
                              className="font-semibold"
                              style={{ margin: "0px" }}
                            >
                              $
                              {booking &&
                                roundUpPrice(booking?.pendingamount / 100)}
                            </p>
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {/* Bartending Company Supplies */}
                {booking.package.type === 'custom_package' &&
                  // booking?.customSupply.filter((i) => i.isbtcprovide).length > 0 
                  // && 
                  (
                    <div className=" bg-white p-5 rounded-xl">
                      <div>
                        <p className="font-semibold text-lg">
                          Bartending Company Provides{" "}
                        </p>
                        {booking.package.type === 'custom_package' && (booking.customSupply.filter((supply: any) => supply.isbtcprovide == true).length > 0 || alcoholStatus.bartenderProvideAlcohol) && booking?.customSupply.map((sup, i) => {
                          if (sup.isbtcprovide) {
                            return (
                              <div
                                key={i}
                                className="flex justify-between items-center"
                              >
                                <p>{sup.name}</p>
                                {/* <p className="font-semibold text-gray-500">${sup.price / 100}</p> */}
                              </div>
                            );
                          }
                        })}
                        {booking.package.type === 'custom_package' && booking &&
                          <div className="flex justify-between">

                            <p>Number of Bartender</p>
                            <p className="text-gray-500">
                              {booking.bartenders.length}
                            </p>
                          </div>
                        }
                        {alcoholStatus.bartenderProvideAlcohol && <div className="flex justify-between items-center"><p>Alcohol</p></div>}
                      </div>
                    </div>
                  )}
                {/* Customer Supplies*/}
                {booking.package.type === 'custom_package' && (booking.customSupply.filter((supply: any) => supply.isbtcprovide == false).length > 0 || alcoholStatus.customerProvideAlcohol) &&
                  // booking?.customSupply.filter((i) => !i.isbtcprovide).length > 0 &&
                  (
                    <div className=" bg-white p-5 rounded-xl">
                      <div>
                        <p className="font-semibold text-lg">
                          Customer Provides{alcoholStatus.customerProvideAlcohol}
                        </p>
                        {booking?.customSupply.map((sup, i) => {
                          if (!sup.isbtcprovide) {
                            return (
                              <div
                                key={i}
                                className="flex justify-between items-center"
                              >
                                <p>{sup.name}</p>
                                {/* <p className="font-semibold text-gray-500">${sup.price / 100}</p> */}
                              </div>
                            );
                          }
                        })}
                        {alcoholStatus.customerProvideAlcohol && <div className="flex justify-between items-center"><p>Alcohol</p></div>}
                        <div></div>
                      </div>
                    </div>
                  )}
                {/* Total Cost */}
                <div className="  p-5 rounded-xl  text-white bg-black">
                  <div className="flex flex-col gap-1  ">
                    <p className="font-semibold text-lg">
                      Total Estimated Event Cost{" "}
                    </p>
                    <div className="flex font-semibold justify-between items-center text-sm px-3 mt-5">
                      <p className="">Package </p>
                      <p className="font-semibold text-gray-400">
                        $
                        {booking && booking.discount_total !== 0
                          ? USFormatePriceWithDecimal(
                            roundUpPrice(
                              (booking.service_total -
                                booking.discount_total) /
                              100
                            )
                          )
                          : booking &&
                          USFormatePriceWithDecimal(
                            roundUpPrice(booking.service_total / 100)
                          )}{" "}
                      </p>
                    </div>
                    {booking?.producttotal ? (
                      <div className="flex font-semibold justify-between items-center text-sm px-3  mb-5">
                        <p className="text-white ">Estimated Alcohol </p>
                        <p className="font-semibold text-gray-400">
                          ${roundUpPrice(booking.producttotal / 100)}
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="flex font-semibold justify-between items-center bg-white py-2 px-4 rounded-2xl h-[63px]">
                      <p className="text-black ">Total Cost </p>
                      <p className={` text-lg text-gray-400 `}>
                        $
                        {booking && booking.discount_total !== 0
                          ? USFormatePriceWithDecimal(
                            roundUpPrice(
                              booking.producttotal / 100 -
                              booking.discount_total / 100 +
                              booking.service_total / 100
                            )
                          )
                          : booking &&
                          USFormatePriceWithDecimal(
                            roundUpPrice(
                              booking.producttotal / 100 +
                              booking.service_total / 100
                            )
                          )}{" "}
                      </p>
                    </div>
                    <p className="text-white  mt-1 px-3 text-xs">
                      This works out to an estimated event cost.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <p className="text-gray-500 text-center">No booking found</p>
          )}
        </>
      ) : (
        <div>
          <Loader color="bg-red-400" />
        </div>
      )}
    </section>
  );
};

const roundUpPrice = (price: number) => {
  const decimalPlaces = 2;
  const factor = Math.pow(10, decimalPlaces);
  const roundedUp = Math.ceil(price * factor) / factor;
  return roundedUp;
};

export function calculateFirstHalfPayment(
  service_total: number,
  platFormFee: number,
  coupon = 0 // TypeScript will infer the type as number from the default value
) {
  const t = service_total - platFormFee - coupon; // coupon will be 0 if nothing is provided
  const dueToday = Math.ceil(t / 2);
  return dueToday + platFormFee;
}

interface CustomInfoIconProps {
  message: string;
  iconColor?: string;
  messageWidth?: string;
}

export default function IButton(
  {
    message,
    iconColor = "currentColor",
    messageWidth = "250px",
  }: CustomInfoIconProps = {
      message: "This is a custom info message.",
      iconColor: "currentColor",
      messageWidth: "250px",
    }
) {
  const [isOpen, setIsOpen] = useState(false);
  const iconRef = useRef<SVGSVGElement>(null);
  const messageRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        isOpen &&
        iconRef.current &&
        !iconRef.current.contains(event.target as Node) &&
        messageRef.current &&
        !messageRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const toggleMessage = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div className=" inline-block">
      <svg
        ref={iconRef}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke={iconColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-4 h-4 cursor-pointer"
        onClick={toggleMessage}
        role="button"
        aria-label="Toggle information"
        tabIndex={0}
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="16" x2="12" y2="12" />
        <line x1="12" y1="8" x2="12.01" y2="8" />
      </svg>
      {isOpen && (
        <div
          ref={messageRef}
          className="absolute p-4 mt-2 bg-white rounded-lg shadow-lg z-20"
          style={{
            width: messageWidth,
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          <p className="text-sm text-gray-400 ">{message}</p>
        </div>
      )}
    </div>
  );
}

export function getNumberOfHours(
  startTime: Date | string,
  endTime: Date | string
) {
  return Math.ceil(
    (toDate(endTime).getTime() - toDate(startTime).getTime()) / (1000 * 3600)
  );
}
